var _rect, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 170,
    viewBox: "0 0 78 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 77,
    height: 122,
    rx: 27.5,
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 39.5,
    y1: 13,
    x2: 39.5,
    y2: 31,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25.3536,
    y1: 137.646,
    x2: 39.3536,
    y2: 151.646,
    stroke: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 19.799,
    y2: -0.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 53 138)",
    stroke: "white"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 29.3536,
    y1: 159.646,
    x2: 39.3536,
    y2: 169.646,
    stroke: "white"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 14.1421,
    y2: -0.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 49 160)",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.72f9bbf26d960540f70cf1aa57cf8b79.svg";
export { ForwardRef as ReactComponent };